import Vue from 'vue';
import VeeValidate from 'vee-validate';
import vueResource from 'vue-resource';

Vue.use(VeeValidate);
Vue.use(vueResource);

Vue.http.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

const url = "/en/contact/send";

const vm = new Vue({
    'el': '#contact-form',
    'data': {
        contact: {
            name: '',
            surname: '',
            email: '',
            message: '',
        },
        sending: false,
        responseMsg: "",
        responseClass: ""
    },
    'methods': {
        // Update on soft keyboards
        onType(e) {
            this.contact[e.target.name] = e.target.value;
        },
        clearForm() {
            for (let field in this.contact) {
                this.contact[field] = '';
                this.$validator.reset();
            }
        },
        submitForm: function (e) {
            this.responseMsg = '';
            this.$validator.validateAll().then((result) => {
                if (result) {
                    // POST FORM
                    this.sending = true;
                    this.$http.post(url, this.contact).then(
                        function (dataSucc) {
                            // console.log(dataSucc);
                            this.responseMsg = dataSucc.body.message;
                            this.responseClass = "text-success";
                            this.sending = false;
                            this.clearForm();
                        },
                        function (dataError) {
                            // console.log(dataError);
                            this.responseMsg = dataError.body.message;
                            this.responseClass = "text-danger";
                            this.sending = false;
                        }
                    );
                } else {
                    this.responseMsg = "Check the fields for errors.";
                    this.responseClass = "text-danger";
                }
            });
        }
    }

});

// window.app = vm;